export function notification() {
  return window.axios.get('/notification');
}